import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
    clearArtistAuthFailure,
    initiateArtistLoginReset,
    initiateLogoutStudio,
    loginArtistAction
} from "../../store/auth/authActions";
import {
    selectArtistLoginResetResult,
    selectArtistLoginResetResultError,
    selectArtistToken,
    selectIsArtistLoginFailed
} from "../../store/auth/authSelector";
import { useTranslation } from "react-i18next";
import { i18_TRANSLATION } from "../../i18nReferences";
import LoginArtistView from "./LoginArtistView";
import LoginContainer from "./LoginContainer";

/**
 * Container component for artist login
 * Manages Redux state for artist login
 * Includes logout button in toolbar to return to studio login
 */
const LoginArtistContainer = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation([i18_TRANSLATION]);
    const isArtistLoginFailed = useSelector(state => selectIsArtistLoginFailed(state));
    const isArtistLoggedIn = useSelector(state => selectArtistToken(state));
    const artistLoginResetResult = useSelector(state => selectArtistLoginResetResult(state));
    const artistLoginResetResultError = useSelector(state => selectArtistLoginResetResultError(state));

    useEffect(() => {
        dispatch(clearArtistAuthFailure());
    }, [dispatch]);

    const loginHandler = data => dispatch(loginArtistAction(data));
    const handleReset = (kuerzel) => dispatch(initiateArtistLoginReset(kuerzel));
    const handleLogoutStudio = () => {
        dispatch(initiateLogoutStudio());
    };

    return (
        <LoginContainer
            maxWidth="sm"
            onExit={handleLogoutStudio}
            showLogoutIcon
        >
            <LoginArtistView
                t={t}
                onSubmit={loginHandler}
                isLoginFailed={isArtistLoginFailed}
                isLoggedIn={!!isArtistLoggedIn}
                successText={t('LOGIN_ARTIST.SUCCESS_TEXT')}
                loginFailedText={t('LOGIN_ARTIST.FAILED_TEXT')}
                nameText={t('LOGIN.ARTIST_KUERZEL')}
                onClickReset={handleReset}
                loginResetResult={artistLoginResetResult}
                loginResetError={artistLoginResetResultError}
            />
        </LoginContainer>
    );
};

export default LoginArtistContainer;